export const WX_CONFIG_FAILED = 'config_failed';

export const DEFAULT_SHARE_IMG =
    'https://cdn-app.nio.com/BEYONDER/2021/7/8/1b2707b9-f497-45e8-b3cd-c802ffa03d26.jpeg';



// WEBPACK FOOTER //
// ./src/util/platform/constants.js